import React, { useState, useEffect } from "react";
import { Grid, Typography, TextField, Autocomplete } from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style.js";
import { formatDateTimeForBackend } from "../../../../Functions.js";
import isOldDateValidate from "../../../../Functions/isOldDateValidate.js";
import Heading from "../../../../StyledComponents/Heading/Heading.js";
import getParameterByName from "../../../../Functions/functions.js";
import paymentTermTooltips from "./constants.js";

const useStyles = makeStyles(dashboardStyle);

const Stylecolor = {
  color: "black",
};

const PaymentDetail = ({
  formState,
  setFormState,
  multipleData,
  disabled,
  setOpenInvalidWarningDate,
  setInvalidWarningDateState,
  alignForAttachment,
}) => {
  const edit = getParameterByName("edit");
  const classes = useStyles();
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        [name]: value,
      },
    }));
  };
  return (
    <div style={{ margin: "20px 0px" }}>
      <Heading title="Payment" />
      <Grid container spacing={1} style={{ marginTop: "3px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          style={{ paddingRight: "18px" }}
        >
          <Typography style={Stylecolor}>Baseline Date:</Typography>
          <input
            className={classes.inputField}
            name="createdDate"
            type="date"
            max="9999-12-31"
            disabled={true}
            style={{
              height: 13,
              color: edit ? "#B4B4B4" : null,
              backgroundColor: edit ? "white" : null,
            }}
            value={
              formState?.invoice_Payment?.createdDate ||
              formState?.invoice_Payment?.CreatedDate
            }
            onChange={(e) => {
              autocompleteChangeHandler(
                "createdDate",
                e.target.value,
                formatDateTimeForBackend(e)
              );
            }}
          />
          {/*
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formState?.invoice_Date || ""}
              onChange={(newValue) => {
                autocompleteChangeHandler("baseLine", newValue);
              }}
              name=""
              error={false}
              // disabled={disabled}
              disabled={true}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label="Outlined"
                  variant="outlined"
                  {...params}
                  error={false}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                />
              )}
            />
                </LocalizationProvider>*/}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={3}
          lg={3}
          style={{ paddingRight: "18px" }}
        >
          <Typography style={Stylecolor}>
            <span className={classes.asterisk}>*</span> Due Date:
          </Typography>
          <input
            className={classes.inputField}
            // style={myStyle.inputField}
            name="dueOn"
            type="date"
            max="9999-12-31"
            error={false}
            disabled={true}
            style={{
              height: 13,
              color: edit ? "#B4B4B4" : null,
              backgroundColor: edit ? "white" : null,
            }}
            required
            value={
              formState?.invoice_Payment?.dueOn ||
              formState?.invoice_Payment?.DueOn ||
              ""
            }
            onChange={(e) => {
              autocompleteChangeHandler(
                "dueOn",
                formatDateTimeForBackend(e.target.value)
              );
            }}
            onInput={(newValue) => {
              isOldDateValidate(
                formatDateTimeForBackend(newValue),
                setOpenInvalidWarningDate,
                setInvalidWarningDateState
              );
              autocompleteChangeHandler(
                "dueOn",
                formatDateTimeForBackend(newValue)
              );
            }}
          />
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={
                formState?.invoice_Payment?.dueOn ||
                formState?.invoice_Payment?.DueOn ||
                ""
              }
              onChange={(newValue) => {
                isOldDateValidate(formatDateTimeForBackend(newValue),
                    setOpenInvalidWarningDate,)
                autocompleteChangeHandler("dueOn", formatDateTimeForBackend(newValue));
              }}
              error={false}
              disabled={disabled}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  name="dueOn"
                  variant="outlined"
                  disabled={disabled}
                  {...params}
                  error={false}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  required
                  onChange={(e) => {
                autocompleteChangeHandler("dueOn", formatDateTimeForBackend(e.target.value));
              }}
                />
              )}
            />
            </LocalizationProvider>*/}
        </Grid>
        {/* Payment Method */}
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography style={Stylecolor}>
            <span className={classes.asterisk}>*</span>Payment Method:
          </Typography>
          <Autocomplete
            id="submitter_role"
            options={multipleData?.paymentMethod || []}
            size="small"
            disabled={!edit}
            // disabled={true}
            sx={{
              "& .MuiInputBase-root": {
                height: "30px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiInputBase-input": {
                marginTop: "-4px", // Adjust this value to move the text up
                fontSize: 15,
              },
            }}
            value={{
              ReferenceCode:
                formState?.invoice_Payment?.paymentMethod ||
                formState?.invoice_Payment?.PaymentMethod ||
                "",
            }}
            // value={formState.invoice_Payment}
            getOptionLabel={(option) =>
              (option !== "" && `${option?.ReferenceCode}`) || ""
            }
            // loading={rolesLoading}
            onChange={(event, newValue) => {
              autocompleteChangeHandler(
                "paymentMethod",
                newValue?.ReferenceCode
              );
            }}
            renderInput={(params) => (
              <TextField {...params} type="text" name="" required />
            )}
          />
        </Grid>
        {/* Payment Terms */}
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography style={Stylecolor}>
            <span className={classes.asterisk}>*</span>Payment Terms:
          </Typography>
          {/* <TextField
            fullWidth
            name="paymentTerms"
            size="small"
            type="text"
            value={formState?.invoice_Payment?.paymentTerms}
            id="outlined-basic"
            variant="outlined"
            onChange={(event) => {
              autocompleteChangeHandler("paymentTerms", event.target.value);
            }}
            disabled
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
          /> */}
          <Autocomplete
            id="submitter_role"
            options={multipleData?.paymentTerms || []}
            size="small"
            value={{
              ReferenceCode: formState.invoice_Payment?.paymentTerms || "",
            }}
            getOptionLabel={(option) =>
              (option !== "" && `${option?.ReferenceCode}`) || ""
            }
            title={paymentTermTooltips[formState.invoice_Payment?.paymentTerms]}
            // loading={rolesLoading}
            onChange={(event, newValue) => {
              autocompleteChangeHandler(
                "paymentTerms",
                newValue?.ReferenceCode
              );
            }}
            disabled={true}
            sx={{
              "& .MuiInputBase-root": {
                height: "30px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiInputBase-input": {
                marginTop: "-4px", // Adjust this value to move the text up
                fontSize: 15,
              },
            }}
            renderInput={(params) => (
              <TextField {...params} type="text" name="" required />
            )}
          />
        </Grid>
        {/* Payment Method Supp */}
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <Typography style={Stylecolor}>
            <span className={classes.asterisk}>*</span>Payment Method Supp:
          </Typography>
          <Autocomplete
            id="submitter_role"
            options={multipleData?.paymentMethSupp || []}
            size="small"
            disabled={!edit}
            // disabled={true}
            sx={{
              "& .MuiInputBase-root": {
                height: "30px",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiInputBase-input": {
                marginTop: "-4px", // Adjust this value to move the text up
                fontSize: 15,
              },
            }}
            value={{
              ReferenceCode:
                formState.invoice_Payment?.paymentMethSupp ||
                formState.invoice_Payment?.paymentMethSupp ||
                "",
            }}
            getOptionLabel={(option) =>
              (option !== "" && `${option?.ReferenceCode}`) || ""
            }
            // loading={rolesLoading}
            onChange={(event, newValue) => {
              autocompleteChangeHandler(
                "paymentMethSupp",
                newValue.ReferenceCode
              );
            }}
            renderInput={(params) => (
              <TextField {...params} type="text" name="" required />
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default PaymentDetail;
